"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
exports.get = utils_1.createAPICall((instance) => config => instance.get('platform', config));
exports.default = utils_1.createAPIModule({ get: exports.get });
//# sourceMappingURL=platform.js.map